import { ManufacturingOrderNotification } from './manufacturing-order-notification';


export class ManufacturingOrderNotifications {

  constructor(
    public notifications?: ManufacturingOrderNotification[],
    public totalPage?: number,
    public total?: number
  ) { }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/manufacturing-order-historical-changes.ts